// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2192":"f715c5e47dc9e2b6","3185":"2f12244ccdb98808","5735":"f715c5e47dc9e2b6"}[chunkId] + ".css";
};